import React from "react";

const BankIcon = ({ width, height, color }) => {
  return (
    <svg

      width="49"
      height="30"
      viewBox="0 0 49 30"

      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.6181 22.9919H25.9812V11.0011H29.9999L15 0L0 11.0011H4.01876V22.9919H2.38184C1.43298 22.9919 0.661152 23.7637 0.661152 24.7125V28.8153H29.3387V24.7125C29.3388 23.7637 28.567 22.9919 27.6181 22.9919ZM3.50347 9.85402L15 1.42273L26.4965 9.85402H3.50347ZM24.8341 11.0011V22.9919H21.8182V11.0011H24.8341ZM20.6711 11.0011V22.9919H17.6552V11.0011H20.6711ZM16.5081 11.0011V22.9919H13.4922V11.0011H16.5081ZM12.3451 11.0011V22.9919H9.32889V11.0011H12.3451ZM8.1818 11.0011V22.9919H5.1659V11.0011H8.1818ZM28.1916 27.6683H1.80829V24.7126C1.80829 24.3961 2.06565 24.139 2.38184 24.139H27.6181C27.9343 24.139 28.1916 24.3962 28.1916 24.7126V27.6683Z"
        fill="#00008B"
      />
    </svg>
  );
};

export default BankIcon;
